import React, { useEffect } from 'react';
import AppHeader from '../Layout/Header';
import FooterComponent from '../Layout/Footer';
import '../Styles/AboutStyles.css'; // Import the CSS for the background image and styling
import NCGSAComponent from '../Components/AboutComponents/NcgsaComponent';
import ScientificObjectives from '../Components/AboutComponents/ScientificObjectives';
import ResearchDomains from '../Components/AboutComponents/ResearchDomains';
import PartnerUniversities from '../Components/AboutComponents/PartnerUniversities';
import NationalSteeringCommittee from '../Components/AboutComponents/NationalSteeringCommittee';
import SecretariatComponent from '../Components/AboutComponents/SecretariatComponent';
import FooterQuote from '../Layout/FooterQuote';
const AboutPage = () => {
    useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, []);
  return (
    <div>
      <AppHeader />

      {/* About section with background image */}
      <div className="about-section" role="img" aria-label="About NCGSA — shaping the future of space and innovation" />
      <main className="page-content-bands">
      <section id="ncgsa-section">
        <NCGSAComponent/>
      </section>

      <section id="scientific-objectives">
        <ScientificObjectives/>
      </section>

      <section id="research-domains">
        <ResearchDomains/>
      </section>

      <section id="partner-universities">
       <PartnerUniversities/>
      </section>

      <section id="national-steering-committee">
       <NationalSteeringCommittee/>
      </section>

      <section id="secretariat">
       <SecretariatComponent/>
      </section>

      </main>
      <FooterQuote
        variant="about"
        quote="To confine our attention to terrestrial matters would be to limit the human spirit."
        attribution="— Stephen Hawking"
      />
      <FooterComponent />
    </div>
  );
};

export default AboutPage;
